// extracted by mini-css-extract-plugin
module.exports = {"card":"hZefi","link":"HZbRL","thumbnail":"GnvvE","figure":"LMMON","icon":"BZmBa","title":"bl75A","place":"MJUyo"};